import _ from 'lodash';
import React, { ChangeEventHandler, DragEventHandler, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useId } from '../hooks';

export const FileDropperElement = styled.label`
    cursor: pointer;
    user-select: none;
    > input {
        display: none;
    }
`

type FileDropperProps = {
    className?: string,
    accept?: string,
    files?: File[] | FileList,
    onFilesDropped?: (files: File[] | FileList) => void
};

const FileDropperNew = ({ className, accept, onFilesDropped }: FileDropperProps, ref:any) => {

    const { id } = useId(5);

    const { t } = useTranslation('common');

    const [fileDragOver, setFileDragOver] = useState<boolean>(false);

    const dragEnterOrOverHandler = useCallback<DragEventHandler<HTMLElement>>((ev) => {
        ev.preventDefault();
        setFileDragOver(true)
    }, [setFileDragOver]);

    const dragLeaveHandler = useCallback<DragEventHandler<HTMLElement>>((ev) => {
        ev.preventDefault();
        setFileDragOver(false);
    }, [setFileDragOver]);

    const handleFileInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>((ev) => {
        ev.preventDefault();

        const { target: { files } } = ev;

        onFilesDropped?.(files || []);

    }, [onFilesDropped]);

    const dropHandler = useCallback<DragEventHandler<HTMLElement>>((ev) => {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        const { dataTransfer: { items, files } } = ev;

        onFilesDropped?.(items.length > 0
            ? _(items).map((i) => i.getAsFile()).filter((f) => f !== null).value() as File[]
            : files);

    }, [onFilesDropped]);

    return (
        <FileDropperElement className={className} htmlFor={`fileDropperInput-${id}`} onDrop={dropHandler} onDragOver={dragEnterOrOverHandler} onDragEnter={dragEnterOrOverHandler} onDragLeave={dragLeaveHandler}>
            <output>{fileDragOver ? t('fileDropper.drop') : t('fileDropper.drag')}</output>
            <input id={`fileDropperInput-${id}`} type="file" multiple accept={accept} onChange={handleFileInputChange} />
        </FileDropperElement>
    );
};

export default FileDropperNew;